import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { BaseView } from '@/components/base'
import { ReasonItem } from '@/components/ReasonItem'
import { Reason, reasonsKey, reasonsList } from './reasonsList'
import { ReportReasonsListProps } from './types'

export const ReportReasonsList: React.FC<ReportReasonsListProps> = ({
  selectedReasons,
  setReasons,
}) => {
  const { t } = useTranslation()

  const toggleReason = useCallback(
    (apiKey: reasonsKey) => {
      if (selectedReasons.includes(apiKey)) {
        setReasons(selectedReasons.filter((reason) => reason !== apiKey))
      } else {
        setReasons([...selectedReasons, apiKey])
      }
    },
    [selectedReasons, setReasons],
  )

  const renderItem = useCallback(
    (item: Reason, index: number) => {
      const sizeList = reasonsList?.length

      if (!sizeList) return null

      const isFirstItem = sizeList > 1 && index === 0
      const isLastItem = sizeList > 1 && index === sizeList - 1
      const haveOnlyOneItem = sizeList === 1

      return (
        <ReasonItem
          key={`${item.apiKey}-${item.id}`}
          isFirstItem={isFirstItem}
          isLastItem={isLastItem}
          haveOnlyOneItem={haveOnlyOneItem}
          title={t(item.translationKey)}
          isChecked={selectedReasons.includes(item.apiKey)}
          onPress={() => toggleReason(item.apiKey)}
          {...item}
        />
      )
    },
    [t, toggleReason, selectedReasons],
  )

  return (
    <BaseView>
      {reasonsList.map((item, index) => renderItem(item, index))}
    </BaseView>
  )
}
